import { FC, SVGProps } from 'react';

export const BurgerMenuIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M4.5 6V7.71429H19.5V6H4.5ZM4.5 12.8571H19.5V11.1429H4.5V12.8571ZM4.5 18H19.5V16.2857H4.5V18Z'
			fill='#C5C5C5'
		/>
	</svg>
);
